import React from "react";

const ViewToggle = ({ view, onViewChange }) => {
  return (
    <div className="flex border border-gray-300 rounded-lg overflow-hidden">
      <button
        className={`flex items-center justify-center px-3 py-1.5 ${
          view === "grid"
            ? "bg-rose-700 text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
        onClick={() => onViewChange("grid")}
        aria-label="Grid view"
        aria-pressed={view === "grid"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
      </button>
      <button
        className={`flex items-center justify-center px-3 py-1.5 ${
          view === "list"
            ? "bg-rose-700 text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
        onClick={() => onViewChange("list")}
        aria-label="List view"
        aria-pressed={view === "list"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 10h16M4 14h16M4 18h16"
          />
        </svg>
      </button>
    </div>
  );
};

export default ViewToggle;
